import type { OrganisationResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetOrganisationQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetOrganisationDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

export const useGetOrganisation = createQueryHook<
  Record<string, never>,
  OrganisationResponseRow[],
  GetOrganisationQuery
>({
  trpcQueryOptions: (trpc) => trpc.frontend.organisation.current.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({ auth_organisation: data }),
  graphqlDocument: GetOrganisationDocument,
});
